/**
 * Gutenberg Blocks
 *
 * All blocks related JavaScript files should be imported here.
 * You can create a new block folder in this dir and include code
 * for that block here as well.
 *
 * All blocks should be included here since this is the file that
 * Webpack is compiling as the input file.
 */
/* eslint-disable camelcase */
__webpack_public_path__ = wpsp_blocks_info.wpsp_base_url + 'dist/';

import './blocks/faq/block.js';
import './blocks/faq-child/block.js';
import './blocks/how-to/block.js';
import './blocks/how-to-child/block.js';
import WPSPBlockIcons from '@Controls/block-icons';
import { updateCategory } from '@wordpress/blocks';

updateCategory('wpsp', {
	icon: WPSPBlockIcons.logo,
});
